(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reishore-bulk-order"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  const section = document.querySelector('.rbo');
  if (!section) return;

  const dataEl = section.querySelector('.rbo__data');
  if (!dataEl) return;

  const { variants, colorOptIndex, sizeOptIndex, productTitle } = JSON.parse(dataEl.textContent);
  const colorKey = 'option' + (colorOptIndex + 1);
  const sizeKey  = 'option' + (sizeOptIndex  + 1);

  // Build colorMap: { colorName: { sizeName: variantObj } }
  const colorMap  = {};
  const sizeOrder = [];
  const seenSizes = new Set();
  // Products without a Color option resolve both keys to the same option —
  // fold everything under a single blank "color" so all sizes land together.
  const hasColor = colorOptIndex !== sizeOptIndex;
  variants.forEach(v => {
    const c = hasColor ? v[colorKey] : '', s = v[sizeKey];
    if (!colorMap[c]) colorMap[c] = {};
    colorMap[c][s] = v;
    if (s && !seenSizes.has(s)) { seenSizes.add(s); sizeOrder.push(s); }
  });

  let selectedColor = Object.keys(colorMap)[0] || null;
  let totalQty = 0;

  const colorsEl   = section.querySelector('.rbo__colors');
  const sizesEl    = section.querySelector('.rbo__sizes');
  const totalNumEl = section.querySelector('.rbo__total-num');
  const msgEl      = section.querySelector('.rbo__msg');
  const addCartBtn = section.querySelector('.rbo__btn--cart');
  const quoteBtn   = section.querySelector('.rbo__btn--quote');

  // ── Render size grid ──────────────────────────────────────────────
  function renderSizes(color) {
    const cv    = colorMap[color] || {};
    const sizes = sizeOrder.filter(s => cv[s]);
    sizesEl.innerHTML = sizes.map(s =>
      '<div class="rbo__size-cell">' +
        '<label class="rbo__size-label" for="rbo-sz-' + s + '">' + s + '</label>' +
        '<input class="rbo__size-qty" type="number" id="rbo-sz-' + s + '" ' +
          'min="0" value="0" inputmode="numeric" ' +
          'data-size="' + s + '" data-vid="' + (cv[s] ? cv[s].id : '') + '">' +
      '</div>'
    ).join('');
    sizesEl.querySelectorAll('.rbo__size-qty').forEach(i => i.addEventListener('input', recalcTotal));
    recalcTotal();
  }

  // ── Recalculate total + addon costs ──────────────────────────────
  function recalcTotal() {
    totalQty = 0;
    sizesEl.querySelectorAll('.rbo__size-qty').forEach(i => { totalQty += parseInt(i.value) || 0; });
    totalNumEl.textContent = totalQty;
    updateAddonCosts();
  }

  function updateAddonCosts() {
    section.querySelectorAll('.rbo__addon-cost').forEach(el => {
      const addonName = el.dataset.addon;
      const yesRadio  = section.querySelector('input[name="rbo-' + addonName + '"][value="yes"]');
      const price     = yesRadio ? (parseFloat(yesRadio.dataset.price) || 0) : 0;
      el.textContent  = '$' + (price * totalQty).toFixed(2);
    });
  }

  // ── Pick a color ──────────────────────────────────────────────────
  function pickColor(color) {
    selectedColor = color;
    colorsEl?.querySelectorAll('.rbo__color-btn').forEach(b => {
      b.classList.toggle('is-active', b.dataset.color === color);
    });
    renderSizes(color);
    // Sync gallery filter (reishore-color-gallery.js listens for this)
    const firstVariant = colorMap[color] ? Object.values(colorMap[color])[0] : null;
    if (firstVariant) {
      document.dispatchEvent(new CustomEvent('variant:update', {
        bubbles: true,
        detail: { resource: firstVariant }
      }));
    }
  }

  // ── Collect form data ─────────────────────────────────────────────
  function collect() {
    const decoration = (section.querySelector('input[name="rbo-decoration"]:checked') || {}).value || '';
    const locations  = Array.from(section.querySelectorAll('input[name="rbo-location"]:checked')).map(i => i.value).join(', ');
    const artNotes   = (section.querySelector('textarea[name="rbo-art-notes"]') || {}).value || '';
    const date       = (section.querySelector('input[name="rbo-date"]') || {}).value || '';
    const turnaround = (section.querySelector('input[name="rbo-turnaround"]:checked') || {}).value || '';
    const foldBag    = section.querySelector('input[name="rbo-foldbag"]:checked')?.value === 'yes';
    const rollBand   = section.querySelector('input[name="rbo-rollband"]:checked')?.value === 'yes';
    const hemTags    = section.querySelector('input[name="rbo-hemtags"]:checked')?.value === 'yes';

    const addonCost = (
      (foldBag  ? 0.85 : 0) +
      (rollBand ? 1.00 : 0) +
      (hemTags  ? 2.25 : 0)
    ) * totalQty;

    const items = [];
    sizesEl.querySelectorAll('.rbo__size-qty').forEach(inp => {
      const qty = parseInt(inp.value) || 0;
      if (qty > 0) items.push({ variantId: inp.dataset.vid, size: inp.dataset.size, qty });
    });

    return { decoration, locations, artNotes, date, turnaround, foldBag, rollBand, hemTags, addonCost, items };
  }

  // ── Messages ──────────────────────────────────────────────────────
  function showMsg(text, type) {
    msgEl.textContent = text;
    msgEl.className   = 'rbo__msg rbo__msg--' + type;
    msgEl.hidden      = false;
    msgEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  // ── Add to Cart ───────────────────────────────────────────────────
  async function addToCart() {
    const d = collect();
    if (!d.items.length) { showMsg('Please enter at least one quantity.', 'error'); return; }
    if (!d.date)         { showMsg('Please enter an in-hand date.', 'error'); return; }

    // All decoration/order details go on the first line item
    const orderProps = {
      'Color': selectedColor || '',
      'Decoration Method': d.decoration,
      'Print Locations': d.locations || 'Not specified',
      'Art Notes': d.artNotes || '—',
      'In-Hand Date': d.date,
      'Turnaround': d.turnaround,
      'Fold + Bag': d.foldBag ? 'Yes' : 'No',
      'Roll + Band': d.rollBand ? 'Yes' : 'No',
      'Sew-On Hem Tags': d.hemTags ? 'Yes' : 'No',
      'Add-on Total': '$' + d.addonCost.toFixed(2)
    };

    const cartItems = d.items.map((item, i) => ({
      id: parseInt(item.variantId, 10),
      quantity: item.qty,
      properties: i === 0
        ? Object.assign({ 'Size': item.size }, orderProps)
        : { 'Color': selectedColor || '', 'Size': item.size }
    }));

    addCartBtn.disabled    = true;
    addCartBtn.textContent = 'Adding…';
    msgEl.hidden           = true;

    try {
      const res  = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: cartItems })
      });
      const json = await res.json();
      if (json.status) throw new Error(json.description || 'Could not add to cart.');
      showMsg('Added to cart! Redirecting…', 'success');
      setTimeout(() => { window.location.href = '/cart'; }, 900);
    } catch (e) {
      showMsg(e.message, 'error');
      addCartBtn.disabled    = false;
      addCartBtn.textContent = 'Add to Cart';
    }
  }

  // ── Request a Quote ───────────────────────────────────────────────
  function requestQuote() {
    const d = collect();
    const addonList = [
      d.foldBag  ? 'Fold + Bag ($' + (0.85 * totalQty).toFixed(2) + ')' : null,
      d.rollBand ? 'Roll + Band ($' + (1.00 * totalQty).toFixed(2) + ')' : null,
      d.hemTags  ? 'Sew-On Hem Tags ($' + (2.25 * totalQty).toFixed(2) + ')' : null
    ].filter(Boolean).join(', ') || 'None';

    const sizeStr = d.items.map(i => i.size + ' x' + i.qty).join(', ') || 'Not entered';

    const note = [
      'Product: ' + productTitle,
      'Color: ' + (selectedColor || 'Not selected'),
      'Decoration: ' + (d.decoration || 'Not selected'),
      'Sizes: ' + sizeStr,
      'Total Qty: ' + totalQty,
      'Print Locations: ' + (d.locations || 'Not specified'),
      'Art Notes: ' + (d.artNotes || 'None'),
      'In-Hand Date: ' + (d.date || 'Not specified'),
      'Turnaround: ' + (d.turnaround || 'Standard'),
      'Add-ons: ' + addonList,
      'Add-on Total: $' + d.addonCost.toFixed(2)
    ].join('\n');

    const params = new URLSearchParams({ note: note, product: productTitle });
    window.location.href = '/pages/get-a-quote?' + params.toString();
  }

  // ── Bind events ───────────────────────────────────────────────────
  colorsEl?.querySelectorAll('.rbo__color-btn').forEach(btn => {
    btn.addEventListener('click', () => pickColor(btn.dataset.color));
  });

  ['rbo-foldbag', 'rbo-rollband', 'rbo-hemtags'].forEach(name => {
    section.querySelectorAll('input[name="' + name + '"]').forEach(r => {
      r.addEventListener('change', updateAddonCosts);
    });
  });

  addCartBtn?.addEventListener('click', addToCart);
  quoteBtn?.addEventListener('click', requestQuote);

  // ── Init ──────────────────────────────────────────────────────────
  if (selectedColor) pickColor(selectedColor);
  else renderSizes(selectedColor);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reishore-product-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var rows = document.querySelectorAll('.rpg__row');
    if (!rows.length) return;

    if (!('IntersectionObserver' in window)) {
      rows.forEach(function (r) { r.classList.add('rpg__row--visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('rpg__row--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    rows.forEach(function (row) { observer.observe(row); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reishore-product-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  const section = document.querySelector('.rpp');
  if (!section) return;

  const dataEl = section.querySelector('.rpp__data');
  if (!dataEl) return;

  const { variants, colorOptIndex, sizeOptIndex, productTitle, colorHexMap = {}, quoteOnly = false } = JSON.parse(dataEl.textContent);
  const colorKey = 'option' + (colorOptIndex + 1);
  const sizeKey  = 'option' + (sizeOptIndex  + 1);

  // ── Build colorMap: { color: { size: variant } } ─────────────────
  const colorMap  = {};
  const sizeOrder = [];
  const seenSizes = new Set();
  // Products without a Color option resolve both keys to the same option —
  // fold everything under a single blank "color" so all sizes land together.
  const hasColor = colorOptIndex !== sizeOptIndex;
  variants.forEach(v => {
    const c = hasColor ? v[colorKey] : '', s = v[sizeKey];
    if (!colorMap[c]) colorMap[c] = {};
    colorMap[c][s] = v;
    if (s && !seenSizes.has(s)) { seenSizes.add(s); sizeOrder.push(s); }
  });

  let selectedColor = Object.keys(colorMap)[0] || null;
  let totalQty = 0;

  // DOM refs
  const colorsEl    = section.querySelector('.rbo__colors');
  const sizesEl     = section.querySelector('.rbo__sizes');
  const estQtyEl    = section.querySelector('.rbo__estqty');
  const totalNumEl  = section.querySelector('.rbo__total-num');

  // Representative variant for the selected color (estimated-quantity mode has no
  // per-size grid, so cart/quote ride the first variant of the chosen color).
  function repVariant() {
    const cv = colorMap[selectedColor] || {};
    const keys = Object.keys(cv);
    return keys.length ? cv[keys[0]] : (variants[0] || null);
  }
  const totalPriceEl = section.querySelector('.rbo__total-price');
  const msgEl       = section.querySelector('.rbo__msg');
  const addCartBtn  = section.querySelector('.rbo__btn--cart');
  const quoteBtn    = section.querySelector('.rbo__btn--quote');

  // ── Gallery ───────────────────────────────────────────────────────
  const slides = Array.from(section.querySelectorAll('.rpp__slide'));
  const thumbs = Array.from(section.querySelectorAll('.rpp__thumb'));

  function activateSlide(index) {
    slides.forEach(s => s.classList.toggle('is-active', parseInt(s.dataset.index) === index));
    thumbs.forEach(t => t.classList.toggle('is-active', parseInt(t.dataset.index) === index));
  }

  function filterGallery(color) {
    // First pass: check if any slide matches the selected color
    let anyMatch = false;
    slides.forEach(s => {
      const img = s.querySelector('img');
      const alt = img ? (img.alt || '') : '';
      if (!color || alt.includes(color)) anyMatch = true;
    });
    // If no images match this color, show all images as fallback
    const effectiveColor = anyMatch ? color : '';

    let firstVisible = -1;
    slides.forEach(s => {
      const img     = s.querySelector('img');
      const alt     = img ? (img.alt || '') : '';
      const matches = !effectiveColor || alt.includes(effectiveColor);
      s.style.display = matches ? '' : 'none';
      if (matches && firstVisible === -1) firstVisible = parseInt(s.dataset.index);
    });
    thumbs.forEach(t => {
      const img     = t.querySelector('img');
      const alt     = img ? (img.alt || '') : '';
      t.style.display = (!effectiveColor || alt.includes(effectiveColor)) ? '' : 'none';
    });
    if (firstVisible !== -1) activateSlide(firstVisible);
  }

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => activateSlide(parseInt(thumb.dataset.index)));
  });

  // ── Size grid ─────────────────────────────────────────────────────
  const STANDARD_SIZES = ['XS','S','M','L','XL','2XL','3XL','4XL','5XL'];

  // Use standard apparel sizes only if the product's sizes are a subset of them;
  // otherwise (caps, bags, "Adjustable", "One Size", etc.) use the actual sizes.
  const allStandard = sizeOrder.length > 0 && sizeOrder.every(s => STANDARD_SIZES.includes(s));
  const SIZES = allStandard ? STANDARD_SIZES.filter(s => sizeOrder.includes(s)) : sizeOrder;

  // Size range under the title comes from option order, which isn't always
  // size order — rewrite it from the properly ordered list.
  const rangeEl = document.querySelector('.rpp__size-range');
  if (rangeEl && SIZES.length > 1) rangeEl.textContent = 'Sizes: ' + SIZES[0] + ' – ' + SIZES[SIZES.length - 1];

  function renderSizes() {
    if (!sizesEl) { recalcTotal(); return; }
    const cv = colorMap[selectedColor] || {};
    // Every size the product carries renders; a size this color doesn't come
    // in (or that's out of stock) shows greyed and disabled, never hidden.
    sizesEl.innerHTML = SIZES.map(s => {
      const v = cv[s];
      // Quote-only products are made to order — no inventory limits there.
      const tracked = !quoteOnly && v && v.inventory_management === 'shopify';
      const stock = tracked ? (v.inventory_quantity || 0) : null;
      const out = !v || (tracked && stock <= 0);
      return '<label class="rbo__size-cell' + (out ? ' is-unavailable' : '') + '">' +
        '<span class="rbo__size-label">' + s + '</span>' +
        (quoteOnly ? '' : '<span class="rbo__size-price">' + (v ? '$' + (v.price / 100).toFixed(2) : '—') + '</span>') +
        '<input class="rbo__size-qty" type="number" min="0" value="" inputmode="numeric" placeholder="0"' +
          ' data-size="' + s + '" data-vid="' + (v ? v.id : '') + '" data-price="' + (v ? v.price || 0 : 0) + '"' +
          (tracked ? ' max="' + stock + '"' : '') +
          (out ? ' disabled' : '') + '>' +
        (!v ? '<span class="rbo__size-inv">Not in this color</span>'
            : out ? '<span class="rbo__size-inv">Out of stock</span>'
            : (tracked ? '<span class="rbo__size-inv">' + stock.toLocaleString() + '</span>' : '')) +
      '</label>';
    }).join('');
    sizesEl.querySelectorAll('.rbo__size-qty').forEach(i => i.addEventListener('input', recalcTotal));
    recalcTotal();
  }

  // ── Totals ────────────────────────────────────────────────────────
  let totalGarmentCost = 0;

  function recalcTotal() {
    totalQty = 0;
    totalGarmentCost = 0;
    const qtyInputs = sizesEl ? sizesEl.querySelectorAll('.rbo__size-qty') : [];
    if (qtyInputs.length) {
      qtyInputs.forEach(i => {
        const q = parseInt(i.value, 10) || 0;
        totalQty += q;
        totalGarmentCost += q * (parseInt(i.dataset.price, 10) || 0);
      });
    } else {
      totalQty = parseInt(estQtyEl && estQtyEl.value, 10) || 0;
      const v = repVariant();
      totalGarmentCost = totalQty * (v ? (parseInt(v.price, 10) || 0) : 0);
    }
    if (totalNumEl) totalNumEl.textContent = totalQty;
    updateAddonCosts();
  }

  function updateAddonCosts() {
    let addonCents = 0;
    section.querySelectorAll('.rbo__addon-cost').forEach(el => {
      const yesRadio = section.querySelector('input[name="rbo-' + el.dataset.addon + '"][value="yes"]:checked');
      const price    = yesRadio ? (parseFloat(yesRadio.dataset.price) || 0) : 0;
      el.textContent = '$' + (price * totalQty).toFixed(2);
      addonCents += price * 100 * totalQty;
    });
    const totalCents = totalGarmentCost + addonCents;
    if (totalPriceEl) totalPriceEl.textContent = '$' + (totalCents / 100).toFixed(2);
  }

  // ── Pick color ────────────────────────────────────────────────────
  function pickColor(color) {
    selectedColor = color;
    colorsEl?.querySelectorAll('.rbo__color-btn').forEach(b => {
      b.classList.toggle('is-active', b.dataset.color === color);
    });
    filterGallery(color);
    renderSizes(color);
  }

  // ── Collect form ──────────────────────────────────────────────────
  // Print locations come from Customily's injected checkboxes (tagged
  // data-rbo-placement by the observer below); falls back to any legacy
  // rbo-location inputs if Customily isn't present on this product.
  function collectLocations() {
    const fromCustomily = Array.from(section.querySelectorAll('.rbo__customily-mount [data-rbo-placement]'))
      .filter(el => el.querySelector('input[type="checkbox"]:checked'))
      .map(el => el.getAttribute('data-rbo-placement').replace(/-/g, ' '));
    if (fromCustomily.length) return fromCustomily.join(', ');
    return Array.from(section.querySelectorAll('input[name="rbo-location"]:checked')).map(i => i.value).join(', ');
  }

  // Harvest Customily's hidden line-item property inputs (e.g.
  // _customily-customization-url, _customily-thumb) from its helper form.
  function customilyProps() {
    const props = {};
    document.querySelectorAll('#rpp-customily-form input[name^="properties["]').forEach(inp => {
      const m = inp.name.match(/^properties\[(.+)\]$/);
      if (m && inp.value) props[m[1]] = inp.value;
    });
    return props;
  }

  function collect() {
    const decoration = (section.querySelector('input[name="rbo-decoration"]:checked') || {}).value || '';
    const locations  = collectLocations();
    const artNotes   = (section.querySelector('textarea[name="rbo-art-notes"]') || {}).value || '';
    const date       = (section.querySelector('input[name="rbo-date"]') || {}).value || '';
    const turnaround = (section.querySelector('input[name="rbo-turnaround"]:checked') || {}).value || '';
    const foldBag    = section.querySelector('input[name="rbo-foldbag"]:checked')?.value === 'yes';
    const rollBand   = section.querySelector('input[name="rbo-rollband"]:checked')?.value === 'yes';
    const hemTags    = section.querySelector('input[name="rbo-hemtags"]:checked')?.value === 'yes';
    const hangTags   = section.querySelector('input[name="rbo-hangtags"]:checked')?.value === 'yes';
    const polybags   = section.querySelector('input[name="rbo-polybags"]:checked')?.value === 'yes';
    const addonCost  = ((foldBag ? 0.85 : 0) + (rollBand ? 1.00 : 0) + (hemTags ? 2.25 : 0)) * totalQty;

    const items = [];
    if (sizesEl) {
      sizesEl.querySelectorAll('.rbo__size-qty').forEach(inp => {
        const qty = parseInt(inp.value, 10) || 0;
        if (qty > 0) items.push({ variantId: inp.dataset.vid, size: inp.dataset.size, qty });
      });
    }
    if (!items.length) {
      const estQty = parseInt(estQtyEl && estQtyEl.value, 10) || 0;
      const rv = repVariant();
      if (estQty > 0 && rv) {
        items.push({ variantId: rv.id, size: sizeOrder.length ? 'Assorted — confirmed on proof' : '', qty: estQty });
      }
    }

    return { decoration, locations, artNotes, date, turnaround, foldBag, rollBand, hemTags, hangTags, polybags, addonCost, items };
  }

  // ── Messages ──────────────────────────────────────────────────────
  function showMsg(text, type) {
    msgEl.textContent = text;
    msgEl.className   = 'rbo__msg rbo__msg--' + type;
    msgEl.hidden      = false;
    msgEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  // ── Add to Cart ───────────────────────────────────────────────────
  async function addToCart() {
    if (artPending > 0) { showMsg('Please wait for your artwork to finish uploading.', 'error'); return; }
    const d = collect();
    if (!d.items.length) { showMsg('Please enter at least one quantity.', 'error'); return; }
    if (!d.date)         { showMsg('Please enter an in-hand date.', 'error'); return; }

    const orderProps = {
      'Color': selectedColor || '',
      'Total Quantity': String(totalQty),
      'Decoration Method': d.decoration,
      'Print Locations': d.locations || 'Not specified',
      'Art Notes': d.artNotes || '—',
      'In-Hand Date': d.date,
      'Turnaround': d.turnaround,
      'Fold + Bag': d.foldBag ? 'Yes' : 'No',
      'Roll + Band': d.rollBand ? 'Yes' : 'No',
      'Sew-On Hem Tags': d.hemTags ? 'Yes' : 'No',
      'Add-on Total': '$' + d.addonCost.toFixed(2)
    };

    // Ride Customily's personalization (design URL + preview thumb) on the
    // first cart line so production gets the print file.
    Object.assign(orderProps, customilyProps(), artworkProps());

    const cartItems = d.items.map((item, i) => ({
      id: parseInt(item.variantId, 10),
      quantity: item.qty,
      properties: i === 0
        ? Object.assign(item.size ? { 'Size': item.size } : {}, orderProps)
        : { 'Color': selectedColor || '', 'Size': item.size }
    }));

    addCartBtn.disabled    = true;
    addCartBtn.textContent = 'Adding…';
    msgEl.hidden           = true;

    try {
      const res  = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: cartItems })
      });
      const json = await res.json();
      if (json.status) throw new Error(json.description || 'Could not add to cart.');
      showMsg('Added to cart! Redirecting…', 'success');
      setTimeout(() => { window.location.href = '/cart'; }, 900);
    } catch (e) {
      showMsg(e.message, 'error');
      addCartBtn.disabled    = false;
      addCartBtn.textContent = 'Add to Cart';
    }
  }

  // ── Basic artwork upload (products without the personalizer) ──────
  const artInput = section.querySelector('.rbo__art-input');
  const artList  = section.querySelector('.rbo__art-files');
  const artFiles = [];
  let artPending = 0;

  if (artInput) {
    artInput.addEventListener('change', () => {
      const files = Array.from(artInput.files || []).slice(0, Math.max(5 - artList.children.length, 0));
      files.forEach(file => {
        const li = document.createElement('li');
        li.textContent = file.name + ' (uploading…)';
        artList.appendChild(li);
        if (file.size > 20 * 1024 * 1024) {
          li.textContent = file.name + ': too large (20 MB max)';
          li.className = 'is-error';
          return;
        }
        artPending++;
        const fd = new FormData();
        fd.append('file', file, file.name);
        fetch(artInput.dataset.endpoint, { method: 'POST', body: fd })
          .then(r => r.json())
          .then(j => {
            if (!j.url) throw new Error(j.error || 'upload failed');
            artFiles.push({ name: file.name, url: j.url });
            li.textContent = file.name + ' (uploaded)';
          })
          .catch(() => {
            li.textContent = file.name + ': upload failed, please email it to us instead';
            li.className = 'is-error';
          })
          .finally(() => { artPending--; });
      });
      artInput.value = '';
    });
  }

  function artworkProps() {
    const props = {};
    artFiles.forEach((f, i) => { props['Artwork ' + (i + 1)] = f.url; });
    return props;
  }

  // ── Request Quote ─────────────────────────────────────────────────
  function requestQuote() {
    if (artPending > 0) { showMsg('Please wait for your artwork to finish uploading.', 'error'); return; }
    const d = collect();
    const addonNames = [];
    if (d.foldBag)  addonNames.push('Fold + Bag');
    if (d.rollBand) addonNames.push('Roll + Band');
    if (d.hemTags)  addonNames.push('Sew-On Hem Tags');
    if (d.hangTags) addonNames.push('Custom Hang Tags');
    if (d.polybags) addonNames.push('Custom Polybags');
    const addonList = addonNames.join(', ') || 'None';

    const sizeStr = d.items.map(i => i.size + ' x' + i.qty).join(', ') || 'Not entered';
    let note = [
      'Product: ' + productTitle,
      'Color: ' + (selectedColor || 'Not selected'),
      'Decoration: ' + (d.decoration || 'Not selected'),
      'Sizes: ' + sizeStr,
      'Total Quantity: ' + (totalQty || 'Not specified'),
      'Print Locations: ' + (d.locations || 'Not specified'),
      'Art Notes: ' + (d.artNotes || 'None'),
      'In-Hand Date: ' + (d.date || 'Not specified'),
      'Turnaround: ' + (d.turnaround || 'Standard'),
      'Add-ons: ' + addonList
    ];
    if (!quoteOnly) {
      note.push('Add-on Total: $' + d.addonCost.toFixed(2));
      note.push('Estimated Total: ' + (totalPriceEl ? totalPriceEl.textContent : '$0.00'));
    }

    const cp = customilyProps();
    if (cp['_customily-customization-url']) note.push('Design File: ' + cp['_customily-customization-url']);
    if (cp['_customily-thumb'])             note.push('Design Preview: ' + cp['_customily-thumb']);
    Object.keys(cp).forEach(k => {
      if (k.indexOf('Artwork — ') === 0 || k === 'Design Preview') note.push(k + ': ' + cp[k]);
    });
    artFiles.forEach(f => note.push('Artwork: ' + f.url));

    note = note.join('\n');

    window.location.href = '/pages/get-a-quote?' + new URLSearchParams({ note, product: productTitle }).toString();
  }

  // ── Apply swatch hex colors ───────────────────────────────────────
  function hexIsLight(hex) {
    const c = hex.replace('#', '');
    const r = parseInt(c.substr(0,2),16), g = parseInt(c.substr(2,2),16), b = parseInt(c.substr(4,2),16);
    return (0.299*r + 0.587*g + 0.114*b) > 160;
  }
  colorsEl?.querySelectorAll('.rbo__color-btn').forEach(btn => {
    const hex = colorHexMap[btn.dataset.color];
    if (hex) {
      btn.style.backgroundColor = hex;
      btn.style.borderColor = hex;
      btn.style.color = hexIsLight(hex) ? '#1a1a1a' : '#ffffff';
    }
  });

  // ── Bind events ───────────────────────────────────────────────────
  colorsEl?.querySelectorAll('.rbo__color-btn').forEach(btn => {
    btn.addEventListener('click', () => pickColor(btn.dataset.color));
  });

  ['rbo-foldbag', 'rbo-rollband', 'rbo-hemtags'].forEach(name => {
    section.querySelectorAll('input[name="' + name + '"]').forEach(r => r.addEventListener('change', updateAddonCosts));
  });

  estQtyEl?.addEventListener('input', recalcTotal);

  addCartBtn?.addEventListener('click', addToCart);
  quoteBtn?.addEventListener('click', requestQuote);

  // Embroidery is quote-only — no direct checkout (headwear gets its own template later)
  function syncDecoration() {
    const emb = (section.querySelector('input[name="rbo-decoration"]:checked') || {}).value === 'Embroidery';
    if (addCartBtn) addCartBtn.disabled = emb;
    const embNote = section.querySelector('.rbo__emb-note');
    if (embNote) embNote.hidden = !emb;
  }
  section.querySelectorAll('input[name="rbo-decoration"]').forEach(r => r.addEventListener('change', syncDecoration));
  syncDecoration();

  // ── Lightbox ──────────────────────────────────────────────────────
  const lightbox    = document.getElementById('rpp-lightbox');
  const lightboxImg = document.getElementById('rpp-lightbox-img');
  const lightboxClose = document.getElementById('rpp-lightbox-close');

  const galleryMain = section.querySelector('.rpp__gallery-main');

  galleryMain?.addEventListener('click', (e) => {
    // Don't open the lightbox when clicking inside Customily's live editor
    // (its canvas mounts in the gallery) — let the customizer handle it.
    if (e.target.closest('.cl-canvas-container, .canvas-container, canvas, .pz__preview, .pz2__preview')) return;
    const activeSlide = section.querySelector('.rpp__slide.is-active');
    if (!activeSlide) return;
    const full = activeSlide.dataset.full;
    const alt  = activeSlide.querySelector('img')?.alt || '';
    lightboxImg.src = full;
    lightboxImg.alt = alt;
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
  });

  function closeLightbox() {
    lightbox.hidden = true;
    lightboxImg.src = '';
    document.body.style.overflow = '';
  }

  lightboxClose?.addEventListener('click', closeLightbox);
  lightbox?.addEventListener('click', e => { if (e.target === lightbox) closeLightbox(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !lightbox.hidden) closeLightbox(); });

  // ── Init ──────────────────────────────────────────────────────────
  if (selectedColor) pickColor(selectedColor);
  else renderSizes();

  // ── Customily placement icons + labelled uploads ──────────────────
  //    Customily is a Vue app — MOVING/WRAPPING its checkbox or upload
  //    nodes breaks its reactivity (toggling stops re-creating uploads).
  //    So we ONLY set attributes (safe) and relabel button text; layout
  //    is done purely in CSS via `order`. We tag each checkbox with
  //    data-rbo-placement (drives the t-shirt icon) and each upload with
  //    data-rbo-upload (drives its label + ordering). The observer re-tags
  //    after Customily re-renders. No node is ever moved. Idempotent.
  (function () {
    var CHK = [
      [/left chest/i, 'left-chest'], [/right chest/i, 'right-chest'],
      [/center chest/i, 'center-chest'], [/front regular/i, 'front-regular'],
      [/front jumbo/i, 'front-jumbo'], [/upper back/i, 'upper-back'],
      [/center back/i, 'center-back'], [/full back/i, 'full-back'],
      [/left sleeve/i, 'left-sleeve'], [/right sleeve/i, 'right-sleeve']
    ];
    var UPL = [
      [/left[- ]?chest/i, 'left-chest'], [/right[- ]?chest/i, 'right-chest'],
      [/cent(?:er|re)[- ]?chest/i, 'center-chest'], [/front[- ]?regular/i, 'front-regular'],
      [/front[- ]?jumbo|jumbo[- ]?front/i, 'front-jumbo'], [/upper[- ]?back/i, 'upper-back'],
      [/cent(?:er|re)[- ]?back/i, 'center-back'], [/full[- ]?back|jumbo[- ]?back/i, 'full-back'],
      [/left[- ]?sleeve/i, 'left-sleeve'], [/right[- ]?sleeve/i, 'right-sleeve']
    ];
    function match(text, map) {
      for (var i = 0; i < map.length; i++) { if (map[i][0].test(text)) return map[i][1]; }
      return null;
    }
    var mt = document.querySelector('.rbo__customily-mount');
    var obs = null;
    function tagAll() {
      var set = mt && mt.querySelector('.customily_set-visibility');
      if (!set) return;
      // Customily has rendered — hide the loading spinner.
      var ld = document.querySelector('.rbo__cust-loading');
      if (ld) ld.classList.add('is-done');
      var opts = set.querySelectorAll('.customily_option');
      var i, o, p;
      for (i = 0; i < opts.length; i++) {
        o = opts[i];
        if (o.classList.contains('cl-has-checkbox')) {
          if (!o.dataset.rboPlacement) {
            p = match(o.textContent || '', CHK);
            if (p) o.setAttribute('data-rbo-placement', p);
          }
        } else if (!o.dataset.rboUpload) {
          p = match(o.textContent || '', UPL);
          if (p) o.setAttribute('data-rbo-upload', p);
        }
      }
      // Relabel "Select Image" → "Upload Image" (text only, no move).
      var sp = set.querySelectorAll('.customily-download-button span');
      for (i = 0; i < sp.length; i++) {
        if (/select image/i.test(sp[i].textContent)) sp[i].textContent = 'Upload Image';
      }
      // Friendlier display labels on the icon tiles (internal match text
      // is kept intact above, so icon mapping is unaffected).
      var RELABEL = { 'center-chest': 'Add center small print' };
      for (var key in RELABEL) {
        var lbl = set.querySelector('.cl-has-checkbox[data-rbo-placement="' + key + '"] .cl-checkbox-inner-label');
        if (!lbl) continue;
        for (var n = 0; n < lbl.childNodes.length; n++) {
          var node = lbl.childNodes[n];
          if (node.nodeType === 3 && node.textContent.trim()) { node.textContent = RELABEL[key]; break; }
        }
      }
    }
    function run() {
      if (obs) obs.disconnect();
      tagAll();
      if (obs) obs.observe(mt, { childList: true, subtree: true });
    }
    if (mt) { obs = new MutationObserver(run); run(); }
  })();

  // ── Bound the sticky mockup: release once Step 5 (Delivery Details)
  //    reaches the top of the screen ─────────────────────────────────
  (function () {
    var leftCol = section.querySelector('.rpp__left');
    var wrap = section.querySelector('.rpp__stickywrap');
    var step5 = section.querySelector('.rbo__step--5');
    if (!leftCol || !wrap || !step5) return;
    var TOP_OFFSET = 16; // matches .rpp__stickywrap top: 1rem

    function updateBound() {
      if (window.matchMedia('(max-width: 899px)').matches) {
        leftCol.style.height = '';
        return;
      }
      var scrollY = window.scrollY || window.pageYOffset;
      var step5Top = step5.getBoundingClientRect().top + scrollY;
      var leftTop = leftCol.getBoundingClientRect().top + scrollY;
      var h = wrap.offsetHeight;
      // Sticky releases when its container bottom is reached; place that
      // bottom so release happens exactly as Step 5 hits the viewport top.
      var bound = Math.max(h, step5Top - leftTop + h + TOP_OFFSET);
      leftCol.style.height = bound + 'px';
    }

    window.addEventListener('load', updateBound);
    window.addEventListener('resize', updateBound);
    if (window.ResizeObserver) {
      // Form height changes when placements expand/collapse — rebound then.
      var fw = section.querySelector('.rpp__form-wrap');
      if (fw) new ResizeObserver(updateBound).observe(fw);
      new ResizeObserver(updateBound).observe(wrap);
    }
    updateBound();
  })();

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reishore-quote-calculator"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var PRICING = {
      tshirt:      { 12: 25.00, 50: 20.00, 100: 16.00, 250: 13.00, 500: 11.00 },
      crewneck:    { 12: 36.00, 50: 30.00, 100: 25.00, 250: 21.00, 500: 18.00 },
      hoodie:      { 12: 42.00, 50: 35.00, 100: 29.00, 250: 25.00, 500: 21.00 },
      polo:        { 12: 30.00, 50: 25.00, 100: 21.00, 250: 17.00, 500: 15.00 },
      tanktop:     { 12: 20.00, 50: 16.00, 100: 13.00, 250: 11.00, 500:  9.00 },
      jacket:      { 12: 65.00, 50: 55.00, 100: 46.00, 250: 40.00, 500: 35.00 },
      shorts:      { 12: 28.00, 50: 23.00, 100: 19.00, 250: 16.00, 500: 13.00 },
      headwear:    { 12: 22.00, 50: 18.00, 100: 15.00, 250: 12.00, 500: 10.00 },
      bag:         { 12: 18.00, 50: 14.00, 100: 11.00, 250:  9.00, 500:  7.00 },
      accessories: { 12: 12.00, 50:  9.00, 100:  7.00, 250:  6.00, 500:  5.00 }
    };

    var currentProduct = 'tshirt';
    var slider = document.getElementById('rqc-slider');
    var qtyDisplay = document.getElementById('rqc-qty');
    var ppuDisplay = document.getElementById('rqc-ppu');
    var totalDisplay = document.getElementById('rqc-total');
    var toggles = document.querySelectorAll('.rqc__toggle');

    function getPrice(product, qty) {
      var tiers = PRICING[product];
      if (qty >= 500) return tiers[500];
      if (qty >= 250) return tiers[250];
      if (qty >= 100) return tiers[100];
      if (qty >= 50)  return tiers[50];
      return tiers[12];
    }

    function formatMoney(n) {
      return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function update() {
      var qty = parseInt(slider.value, 10);
      var ppu = getPrice(currentProduct, qty);
      qtyDisplay.textContent = qty;
      ppuDisplay.textContent = formatMoney(ppu);
      totalDisplay.textContent = formatMoney(qty * ppu);
    }

    toggles.forEach(function(btn) {
      btn.addEventListener('click', function() {
        currentProduct = btn.dataset.product;
        toggles.forEach(function(b) {
          b.classList.remove('rqc__toggle--active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('rqc__toggle--active');
        btn.setAttribute('aria-pressed', 'true');
        update();
      });
    });

    if (slider) {
      slider.addEventListener('input', update);
      update();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reishore-quote-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var params = new URLSearchParams(window.location.search);
    var note = params.get('note');
    if (note) {
      var ta = document.getElementById('RQF-Notes');
      if (ta && !ta.value.trim()) ta.value = note;
    }
  })();

  (function () {
    var input = document.getElementById('RQF-Artwork');
    var form = document.getElementById('RQF-ContactForm');
    if (!input || !form) return;
    var list = document.getElementById('RQF-ArtworkList');
    var hidden = document.getElementById('RQF-ArtworkLinks');
    var button = form.querySelector('[type="submit"]');
    var endpoint = input.dataset.endpoint;
    var MAX_FILES = 5;
    var MAX_BYTES = 20 * 1024 * 1024;
    var urls = [];
    var pending = 0;

    function sync() {
      hidden.value = urls.join('\n');
      button.disabled = pending > 0;
    }

    function upload(file) {
      var li = document.createElement('li');
      li.textContent = file.name + ' (uploading…)';
      list.appendChild(li);
      if (file.size > MAX_BYTES) {
        li.textContent = file.name + ': too large (20 MB max)';
        li.className = 'is-error';
        return;
      }
      pending++;
      sync();
      var fd = new FormData();
      fd.append('file', file, file.name);
      fetch(endpoint, { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (!j.url) throw new Error(j.error || 'upload failed');
          urls.push(j.url);
          li.textContent = file.name + ' (uploaded)';
        })
        .catch(function () {
          li.textContent = file.name + ': upload failed, please email it to us instead';
          li.className = 'is-error';
        })
        .finally(function () {
          pending--;
          sync();
        });
    }

    input.addEventListener('change', function () {
      var files = Array.prototype.slice.call(input.files || []);
      var room = MAX_FILES - list.children.length;
      files.slice(0, Math.max(room, 0)).forEach(upload);
      input.value = '';
    });

    form.addEventListener('submit', function (e) {
      if (pending > 0) e.preventDefault();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reishore-shop-all"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sel = document.getElementById('rsa-limit-select');
    if (!sel) return;

    // Reflect current ?limit= in the select
    const params = new URLSearchParams(window.location.search);
    const current = params.get('limit');
    if (current) {
      const opt = sel.querySelector(`option[value="${current}"]`);
      if (opt) opt.selected = true;
    }

    sel.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('limit', this.value);
      url.searchParams.delete('page'); // reset to page 1
      window.location.href = url.toString();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reishore-sports-uniform-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.rsub-page').forEach(function (root) {
      var form = root.querySelector('.rsub__form');
      if (!form) return;
      var variants = JSON.parse(root.querySelector('.rsub__variants').textContent);
      var tierIdx = parseInt(form.dataset.tierIndex, 10);
      var configIdx = parseInt(form.dataset.configIndex, 10);
      var topsInput = root.querySelector('[data-qty-tops]');
      var bottomsInput = root.querySelector('[data-qty-bottoms]');
      var bottomsField = root.querySelector('[data-bottoms-field]');
      var topsField = root.querySelector('[data-tops-field]');
      var topsLabel = root.querySelector('label[for="rsub-tops"]');
      var configRadios = root.querySelectorAll('[data-config]');
      var totalEl = root.querySelector('[data-total-qty]');
      var tierEl = root.querySelector('[data-current-tier]');
      var unitEl = root.querySelector('[data-unit-price]');
      var subEl = root.querySelector('[data-subtotal]');
      var submitBtn = root.querySelector('[data-submit]');
      var msgEl = root.querySelector('[data-msg]');
      var productTitle = (root.querySelector('.rpp__title') || {}).textContent || document.title;

      var totalLabelEl = root.querySelector('[data-total-label]');
      var currentConfig = configRadios.length > 0 ? configRadios[0].dataset.config : (form.dataset.singleConfig || null);

      function isSet() { return !!currentConfig && /set|kit/i.test(currentConfig); }
      function unitWord() { return isSet() ? 'sets' : 'units'; }
      function qtyLabel() { return isSet() ? 'Total sets' : 'Total quantity'; }

      function tierForQty(qty) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var tierVal = tierIdx === 0 ? v.option1 : tierIdx === 1 ? v.option2 : v.option3;
          if (!tierVal) continue;
          var parts = tierVal.split('-');
          var lo = parseInt(parts[0], 10);
          var hi = parts[1] ? parseInt(parts[1], 10) : Infinity;
          if (qty < lo || qty > hi) continue;
          if (configIdx >= 0 && currentConfig) {
            var cfgVal = configIdx === 0 ? v.option1 : configIdx === 1 ? v.option2 : v.option3;
            var vT = /top/i.test(cfgVal || ''), vB = /bottom/i.test(cfgVal || '');
            if (isSet()) {
              if (!(vT && vB)) continue;            // a set maps to the tops-and-bottoms variant
            } else if (/top/i.test(currentConfig) || /bottom/i.test(currentConfig)) {
              var wT = /top/i.test(currentConfig), wB = /bottom/i.test(currentConfig);
              if (wT !== vT || wB !== vB) continue;
            }
            // else single garment: ignore config, match by tier only
          }
          return v;
        }
        return null;
      }

      function fmt(n) { return '$' + (n / 100).toFixed(2); }

      function numVal(el) {
        var n = el ? parseInt(el.value, 10) : 0;
        return isNaN(n) || n < 0 ? 0 : n;
      }

      function setCount() { return numVal(topsInput); }

      function recalc() {
        if (topsLabel) topsLabel.textContent = qtyLabel();
        if (totalLabelEl) totalLabelEl.textContent = qtyLabel();

        var sets = setCount();
        totalEl.textContent = sets;

        if (sets < 2) {
          tierEl.textContent = sets === 0 ? '—' : 'Below minimum';
          unitEl.textContent = '$0.00';
          subEl.textContent = '$0.00';
          submitBtn.disabled = true;
          return;
        }

        var v = tierForQty(sets);
        if (!v) {
          tierEl.textContent = 'Contact for quote';
          unitEl.textContent = '$0.00';
          subEl.textContent = '$0.00';
          submitBtn.disabled = false; // still allow quote requests beyond tiers
          return;
        }

        var tierLabel = tierIdx === 0 ? v.option1 : tierIdx === 1 ? v.option2 : v.option3;
        tierEl.textContent = tierLabel + ' ' + unitWord();
        unitEl.textContent = fmt(v.price);
        subEl.textContent = fmt(v.price * sets);
        submitBtn.disabled = false;
      }

      function requestQuote() {
        if (submitBtn.disabled) return;
        var sets = setCount();
        var logos = [];
        root.querySelectorAll('.rsub__file').forEach(function (f) {
          if (f.files && f.files.length) logos.push(f.files[0].name);
        });

        var note = [
          'Product: ' + productTitle.trim(),
          'Configuration: ' + (currentConfig || 'Not selected'),
          (isSet() ? 'Total sets: ' : 'Total quantity: ') + setCount()
        ];
        note.push('Pricing tier: ' + (tierEl.textContent || '—'));
        note.push('Estimated per-set: ' + (unitEl.textContent || '—'));
        note.push('Estimated total: ' + (subEl.textContent || '—') + ' (reference)');
        note.push('Logos: ' + (logos.length ? logos.join(', ') : 'To be provided'));
        if (window.RPZ2 && window.RPZ2.layers && window.RPZ2.layers.length) {
          window.RPZ2.layers.forEach(function (L, i) {
            note.push('Artwork — Design ' + (i + 1) + ' (' + (L.view === 'front' ? 'Front' : 'Back') + '): ' +
              (L.remoteUrl || L.file.name) + ' | all-over placement, customer-arranged (estimate)');
          });
          if (window.RPZ2.thumbUrl) note.push('Design Preview: ' + window.RPZ2.thumbUrl);
        }
        var designHelp = root.querySelector('[data-design-help]');
        if (designHelp && designHelp.checked) note.push('Design help requested: Yes (no print-ready art yet)');
        var artNotes = root.querySelector('[data-art-notes]');
        if (artNotes && artNotes.value.trim()) note.push('Art notes: ' + artNotes.value.trim());
        note.push('Decoration: full-color all-over sublimated cut & sew.');
        note.push('Note: final sizes, names & numbers to be confirmed.');

        var qs = new URLSearchParams({ note: note.join('\n'), product: productTitle.trim() });
        window.location.href = '/pages/get-a-quote?' + qs.toString();
      }

      [topsInput].forEach(function (i) {
        if (!i) return;
        i.addEventListener('input', recalc);
        i.addEventListener('change', recalc);
      });

      configRadios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          currentConfig = radio.dataset.config;
          recalc();
          showConfigImage();
        });
      });

      submitBtn.addEventListener('click', requestQuote);

      // Multi-file upload
      var filesWrap = root.querySelector('[data-files]');
      var addBtn = root.querySelector('[data-add-file]');
      if (addBtn && filesWrap) {
        addBtn.addEventListener('click', function () {
          var existing = filesWrap.querySelectorAll('.rsub__file-row').length;
          var n = existing + 1;
          var row = document.createElement('div');
          row.className = 'rsub__file-row';
          row.innerHTML = '<input type="file" name="properties[Logo ' + n + ']" accept=".png,.jpg,.jpeg,.pdf,.ai,.eps,.svg" class="rsub__file" />' +
                          '<button type="button" class="rsub__remove-file" aria-label="Remove">×</button>';
          row.querySelector('.rsub__remove-file').addEventListener('click', function () {
            row.remove();
          });
          filesWrap.appendChild(row);
        });
      }

      // Thumbnail switching + config-driven image
      var thumbs = root.querySelectorAll('.rpp__thumb');
      var slides = root.querySelectorAll('.rpp__slide');

      function activateImage(idx) {
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        slides.forEach(function (x) { x.classList.remove('is-active'); });
        if (slides[idx]) slides[idx].classList.add('is-active');
        if (thumbs[idx]) thumbs[idx].classList.add('is-active');
      }

      // Show the image whose alt text contains the selected configuration
      // (e.g. alt "...Tops only" / "...Bottoms only" / "...Tops and Bottoms").
      function showConfigImage() {
        if (!currentConfig) return;
        var want = currentConfig.toLowerCase().trim();
        for (var i = 0; i < slides.length; i++) {
          var img = slides[i].querySelector('img');
          var alt = (img && img.alt ? img.alt : '').toLowerCase();
          if (alt.indexOf(want) !== -1) { activateImage(i); return; }
        }
      }

      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { activateImage(i); });
      });

      recalc();
      showConfigImage();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reishore-techpack-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.getElementById('RTP-ContactForm');
    if (!form) return;
    var disabled = [];

    var preset = new URLSearchParams(window.location.search).get('garment');
    if (preset && /^[a-z]+$/.test(preset)) {
      var pre = form.querySelector('.rtp__garment-input[data-garment="' + preset + '"]');
      if (pre && !form.querySelector('.rtp__garment-input:checked')) pre.checked = true;
    }

    function val(el) {
      return el && el.value ? el.value.trim() : '';
    }

    function activeKey() {
      var r = form.querySelector('.rtp__garment-input:checked');
      return r ? r.dataset.garment : '';
    }

    function qtyGrid(key) {
      return form.querySelector(key === 'headwear' ? '.rtp__qty--headwear' : '.rtp__qty--apparel');
    }

    function updateTotals() {
      form.querySelectorAll('.rtp__qty').forEach(function (grid) {
        var total = 0;
        grid.querySelectorAll('input').forEach(function (i) {
          var n = parseInt(i.value, 10);
          if (n > 0) total += n;
        });
        grid.querySelector('[data-rtp-total]').textContent = total;
      });
    }

    function setOut(name, lines) {
      var out = form.querySelector('[data-rtp-out="' + name + '"]');
      if (out) out.value = lines.join('\n');
    }

    function measurements(key) {
      var lines = [];
      var block = form.querySelector('.rtp__pom[data-garment="' + key + '"]');
      if (!block) return lines;
      block.querySelectorAll('tbody tr').forEach(function (tr) {
        var parts = [];
        tr.querySelectorAll('input[data-size]').forEach(function (i) {
          if (val(i)) parts.push(i.dataset.size + ' ' + val(i));
        });
        if (parts.length) lines.push('• ' + tr.dataset.pom + ': ' + parts.join(' / '));
      });
      if (lines.length) lines.push('(units: ' + val(form.querySelector('[name="contact[Units]"]:checked')) + ')');
      return lines;
    }

    function quantities(key) {
      var parts = [];
      var total = 0;
      qtyGrid(key).querySelectorAll('input[data-size]').forEach(function (i) {
        var n = parseInt(i.value, 10);
        if (n > 0) {
          parts.push(i.dataset.size + ' × ' + n);
          total += n;
        }
      });
      return parts.length ? ['• ' + parts.join(', ') + ' (total ' + total + ')'] : [];
    }

    function rows(table) {
      var lines = [];
      table.querySelectorAll('tbody tr').forEach(function (tr, idx) {
        var parts = [];
        tr.querySelectorAll('[data-label]').forEach(function (el) {
          if (val(el)) parts.push(el.dataset.label + ': ' + val(el));
        });
        if (parts.length) lines.push('• ' + (idx + 1) + '. ' + parts.join('; '));
      });
      return lines;
    }

    function off(el) {
      if (!el.disabled) {
        el.disabled = true;
        disabled.push(el);
      }
    }

    form.addEventListener('input', function (e) {
      if (e.target.closest('.rtp__qty')) updateTotals();
    });

    function highlight(block, letter) {
      block.querySelectorAll('.rtp-m.is-active').forEach(function (g) {
        g.classList.remove('is-active');
      });
      if (!letter) return;
      block.querySelectorAll('.rtp-m[data-l="' + letter + '"]').forEach(function (g) {
        g.classList.add('is-active');
      });
    }

    form.addEventListener('focusin', function (e) {
      var tr = e.target.closest('.rtp__pom tr[data-letter]');
      if (tr) highlight(tr.closest('.rtp__pom'), tr.dataset.letter);
    });

    form.addEventListener('focusout', function (e) {
      var block = e.target.closest('.rtp__pom');
      if (block && !block.contains(e.relatedTarget)) highlight(block, '');
    });

    form.addEventListener('click', function (e) {
      var g = e.target.closest('.rtp-m');
      if (!g) return;
      var block = g.closest('.rtp__pom');
      var tr = block.querySelector('tr[data-letter="' + g.dataset.l + '"]');
      if (!tr) return;
      var inputs = Array.prototype.slice.call(tr.querySelectorAll('input'));
      var target = inputs.filter(function (i) { return !i.value; })[0] || inputs[0];
      target.focus({ preventScroll: true });
      highlight(block, g.dataset.l);
      tr.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'smooth' });
    });

    form.addEventListener('submit', function () {
      var key = activeKey();
      setOut('measurements', measurements(key));
      setOut('quantities', quantities(key));
      form.querySelectorAll('[data-rtp-rows]').forEach(function (t) {
        setOut(t.dataset.rtpRows, rows(t));
      });

      form.querySelectorAll('[data-rtp-cell]').forEach(off);
      form.querySelectorAll('.rtp__by-garment').forEach(function (b) {
        if (b.dataset.garment !== key) b.querySelectorAll('input, select, textarea').forEach(off);
      });
      if (key === 'headwear') form.querySelectorAll('.rtp__apparel-only select').forEach(off);
      form.querySelectorAll('input, select, textarea').forEach(function (el) {
        if (el.type === 'radio' || el.type === 'checkbox' || el.type === 'submit') return;
        if (el.name && el.name.indexOf('contact[') === 0 && !val(el)) off(el);
      });
    });

    window.addEventListener('pageshow', function () {
      disabled.forEach(function (el) {
        el.disabled = false;
      });
      disabled = [];
      updateTotals();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reishore-wholesale-category"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var rows = document.querySelectorAll('.rwc__row');
    if (!rows.length) return;
    if (!('IntersectionObserver' in window)) {
      rows.forEach(function (r) { r.classList.add('rwc__row--visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('rwc__row--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    rows.forEach(function (row) { observer.observe(row); });
  })();

  } catch(e) { console.error(e); }
})();
})();
